import * as tracking from 'dibs-tracking';

export type CallSellerModalLocation =
    | 'pdp'
    | 'storefront'
    | 'mc'
    | 'mcEmail'
    | 'sellerProfile'
    | 'conversationBody';

const trackingCategory = 'contact dealer';
const locationLabels: Record<CallSellerModalLocation, string> = {
    pdp: 'more from dealer',
    storefront: 'dealer storefront',
    mc: 'message center',
    sellerProfile: 'message center - seller profile',
    conversationBody: 'message center - conversation body',
    mcEmail: 'message center - email',
};

export const onCallModalOpen = (location: CallSellerModalLocation): void => {
    tracking.trackEvent({
        category: trackingCategory,
        action: 'call dealer clicked',
        label: locationLabels[location],
    });
};

export const onCallModalSuccess = (
    location: CallSellerModalLocation,
    allowDealerCallback?: boolean
): void => {
    tracking.trackEvent({
        category: trackingCategory,
        action: 'call dealer initiated',
        label: locationLabels[location],
        value: allowDealerCallback ? 1 : 0,
    });
};
